/**
 * What actually happens when somebody pets her.
 *
 * Kept out of `interaction.ts` on purpose: the engine reads `affectionNow`
 * from there on every line, so that module must not import the engine back.
 * This one may — it is a call site like any other.
 *
 * The animation always plays (the mark handles it). The line is rationed by
 * the store — first pet of the day speaks, later ones rarely, never more than
 * twice a day, never on a cooled day — and the dry register stays wordless by
 * construction: there is no dry `petted` pool, so `sassLine` returns null and
 * the slow-blink is the whole answer. „Ta pati aš, tik užčiaupta."
 */

import { sassLine } from '../sass/engine.js'
import { showSassToast } from '../shell/toastStore.js'
import { recordPet } from './interaction.js'

export function petHer(): void {
  const speaks = recordPet()
  if (!speaks) return
  const line = sassLine('petted')
  if (line != null) showSassToast(line)
}
